// Positions Judge.me's official product medals in the review widget header.
(() => {
  const containerClass = 'nomitail-judgeme-product-medals';
  const itemClass = `${containerClass}__item`;
  const styleId = 'nomitail-judgeme-product-medals-style';

  const addStyles = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .${containerClass} {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        margin-inline-start: 8px;
        flex: 0 0 auto;
        line-height: 1;
        vertical-align: middle;
      }

      .${itemClass} {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 58px;
        height: 58px;
        flex: 0 0 58px;
      }

      .${itemClass} img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      @media (max-width: 749px) {
        .${containerClass} {
          gap: 4px;
          margin-inline-start: 6px;
        }

        .${itemClass} {
          width: 46px;
          height: 46px;
          flex-basis: 46px;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const readWidgetData = () => {
    const dataScript = document.querySelector('script.jdgm-review-widget-data');
    if (!dataScript?.textContent) return null;

    const reviewWidgetData = window.jdgm?.data?.reviewWidget;
    if (reviewWidgetData && typeof reviewWidgetData === 'object') {
      const productId = window.meta?.product?.id || window.ShopifyAnalytics?.meta?.product?.id;
      const currentProductData = productId ? reviewWidgetData[String(productId)] : null;
      if (currentProductData) return currentProductData;

      const firstProductData = Object.values(reviewWidgetData)[0];
      if (firstProductData) return firstProductData;
    }

    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      const assignment = dataScript.textContent.match(/reviewWidget\[\d+\]\s*=\s*/);
      if (!assignment) return null;

      try {
        const jsonStart = assignment.index + assignment[0].length;
        return JSON.parse(dataScript.textContent.slice(jsonStart).trim().replace(/;\s*$/, ''));
      } catch (assignmentError) {
        return null;
      }
    }
  };

  const removeMedals = () => {
    document.querySelectorAll(`.${containerClass}`).forEach((container) => container.remove());
  };

  const renderMedals = () => {
    if (window.jdgmSettings?.widget_show_product_medals === false) {
      removeMedals();
      return false;
    }

    const widget = document.querySelector('.jdgm-review-widget');
    const averageRating = widget?.querySelector('.jm-average-rating-display');
    const ratingRow = averageRating?.parentElement;
    const data = readWidgetData();
    const medals = Array.isArray(data?.product_medals)
      ? data.product_medals.filter((medal) => medal?.medal_image_url)
      : [];

    if (!widget || !averageRating || !ratingRow) return false;

    if (!medals.length) {
      removeMedals();
      return true;
    }

    const signature = medals
      .map((medal) => [medal.type, medal.tier, medal.medal_image_url].join(':'))
      .join('|');
    let container = widget.querySelector(`.${containerClass}`);

    if (container?.dataset.signature === signature && container.parentElement === ratingRow) {
      return true;
    }

    container?.remove();
    container = document.createElement('span');
    container.className = containerClass;
    container.dataset.signature = signature;
    container.setAttribute('role', 'list');
    container.setAttribute('aria-label', 'Judge.me product review medals');

    medals.forEach((medal) => {
      const title = medal.title || medal.medal_title || medal.name || 'Judge.me product medal';
      const description = medal.description || medal.medal_description || '';
      const item = document.createElement('span');
      const image = document.createElement('img');

      item.className = itemClass;
      item.setAttribute('role', 'listitem');
      item.title = [title, description].filter(Boolean).join(' — ');

      image.src = medal.medal_image_url;
      image.alt = title;
      image.width = 58;
      image.height = 58;
      image.loading = 'lazy';
      image.decoding = 'async';

      item.appendChild(image);
      container.appendChild(item);
    });

    addStyles();
    ratingRow.appendChild(container);
    return true;
  };

  let frame = 0;
  const queueRender = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      renderMedals();
    });
  };

  const observer = new MutationObserver(queueRender);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const retryTimer = window.setInterval(() => {
    attempts += 1;
    const rendered = renderMedals();
    if (rendered || attempts >= 120) window.clearInterval(retryTimer);
  }, 500);

  document.addEventListener('DOMContentLoaded', queueRender, { once: true });
  document.addEventListener('shopify:section:load', queueRender);
  window.addEventListener('pageshow', queueRender);
  queueRender();
})();
